<router-outlet></router-outlet>
<ngx-spinner
  [bdColor]="'rgba(255, 255, 255, 0.7)'"
  size="medium"
  color="rgba(26, 115, 232, 0.9)"
  type="ball-scale-multiple"
>
</ngx-spinner>

<notifier-container></notifier-container>
